/* globals Raven */
/* eslint moduleName:0 */

"use strict";

(function () {
    var itsoftApp;
    var pageHeader = document.querySelector(".page-header");
    var slice = [].slice;

    var noScript = document.querySelector("[data-no-script]");

    if (noScript) {
        noScript.removeAttribute("data-no-script");
    }

    window.itsoftApp = itsoftApp = {
        createNS: function (namespace) {
            var i, len, nsparts, parent, part;
            nsparts = namespace.split(".");
            parent = itsoftApp;

            // we want to be able to include or exclude the root namespace so we strip
            // it if it's in the namespace
            if (nsparts[0] === "itsoftApp") {
                nsparts = nsparts.slice(1);
            }

            // loop through the parts and create a nested namespace if necessary
            for (i = 0, len = nsparts.length; i < len; i++) {
                part = nsparts[i];

                // check if the current parent already has the namespace declared
                // if it isn't, then create it
                if (typeof parent[part] === "undefined") {
                    parent[part] = {};
                }

                // get a reference to the deepest element in the hierarchy so far
                parent = parent[part];
            }

            return parent;
        },

        isLocal: !!document.getElementById("js-server-local"),

        libraries: {
            gsap: {
                name: "gsap",
                queue: [],
                started: false,
                loaded: false,
                script: "/assets/scripts/gsap/gsap.min.js",
                cb: function () {
                    DEBUG && console.log("GSAP");
                }
            },

            scrollTrigger: {
                name: "scrollTrigger",
                queue: [],
                started: false,
                loaded: false,
                dependency: "gsap",
                script: "/assets/scripts/gsap/ScrollTrigger.min.js",
                cb: function () {
                    gsap.registerPlugin(ScrollTrigger);
                }
            },
            
            scrollToPlugin: {
                name: "scrollTo",
                queue: [],
                started: false,
                loaded: false,
                dependency: "gsap",
                script: "/assets/scripts/gsap/ScrollToPlugin.min.js",
                cb: function () {
                    gsap.registerPlugin(ScrollToPlugin);
                }
            },
            
            smoothScroll: {
                name: "smoothScroll",
                queue: [],
                started: false,
                loaded: false,
                script: "/assets/scripts/smoothScroll/smooth-scroll.min.js"
            },
    
            slider: {
                name: "swiper",
                queue: [],
                started: false,
                loaded: false,
                style: "/assets/scripts/swiper/swiper.min.css",
                script: "/assets/scripts/swiper/swiper.min.js",
                cb: function () {
                    Swiper.initedSliders = {};
                }
            }
        },

        utils: {
            debouncer: function (func, timeout) {
                var timeoutID;
                if (timeout == null) {
                    timeout = 200;
                }
                timeoutID = undefined;
                return function () {
                    var args, scope;
                    scope = this;
                    args = arguments;
                    clearTimeout(timeoutID);
                    timeoutID = setTimeout(function () {
                        func.apply(scope, Array.prototype.slice.call(args));
                    }, timeout);
                };
            },

            throttler: function (func, ms) {
                var isThrottled = false,
                    savedArgs,
                    savedThis;
                
                function wrapper () {
                
                    if (isThrottled) { // (2)
                        savedArgs = arguments;
                        savedThis = this;
                        return;
                    }
                
                    func.apply(this, arguments); // (1)
                
                    isThrottled = true;
                
                    setTimeout(function () {
                        isThrottled = false; // (3)
                        if (savedArgs) {
                            wrapper.apply(savedThis, savedArgs);
                            savedArgs = savedThis = null;
                        }
                    }, ms);
                }
                
                return wrapper;
            },

            // Stealed from
            // https://github.com/VodkaBears/Remodal
            getScrollbarWidth: function () {
                return window.innerWidth - document.documentElement.clientWidth;
            },

            // TODO
            // REPAINT
            // Вызывает Recalculate Style
            // Проверить, из-за чего, и можно ли избавиться
            getScrTop: function () {
                var $body, $document, $wrapper, scrTop;
                $document = itsoftApp.commonVars.$document;
                $body = itsoftApp.commonVars.$body;
                $wrapper = itsoftApp.commonVars.$wrapper;
                scrTop = Math.max($document.scrollTop, $body.scrollTop, $wrapper.scrollTop, 0);
                // console.log($document.scrollTop(), $body.scrollTop(), $wrapper.scrollTop())
                return scrTop;
            },

            getTime: (function () {
                var res;
                if (window.performance && typeof window.performance.now === "function") {
                    res = function (precision) {
                        if (precision == null) {
                            precision = 1;
                        }
                        return parseFloat(window.performance.now().toFixed(precision));
                    };
                } else {
                    res = function (precision) {
                        if (precision == null) {
                            precision = 1;
                        }
                        return parseFloat(new Date().getTime().toFixed(precision));
                    };
                }
                return res;
            })(),

            newMeasureFunc: function (precision) {
                var res, t0;
                if (precision == null) {
                    precision = 2;
                }
                t0 = itsoftApp.utils.getTime(precision);
                res = function () {
                    var t1, t2;
                    t1 = itsoftApp.utils.getTime(precision);
                    t2 = parseFloat((t1 - t0).toFixed(precision));
                    t0 = t1;
                    return t2;
                };
                return res;
            },

            getInitTimes: function () {
                var k, module, obj, ref, total;
                obj = {};
                total = 0;
                ref = itsoftApp.modules;
                for (k in ref) {
                    module = ref[k];
                    if (module.initialized && module.__mName__ !== undefined) {
                        obj[module.__mName__] = module.__initTime__;
                        total += module.__initTime__;
                    }
                }
                obj.all = Math.round(total);
                return obj;
            },

            checkIsSafari: function () {
                var UA = navigator.userAgent.toLowerCase();

                if (UA.indexOf("safari") != -1) {
                    if (UA.indexOf("chrome") > -1) {
                        return;
                    } else {
                        return true;
                    }
                }
            },

            getViewportSize: function () {
                if (itsoftApp.utils.checkIsSafari()) {
                    itsoftApp.commonVars.viewWidth = document.documentElement.clientWidth;
                } else {
                    itsoftApp.commonVars.viewWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
                }

                return itsoftApp.commonVars.viewWidth;
            },

            getViewportHeight: function () {
                itsoftApp.commonVars.viewHeight = document.documentElement.clientHeight;
                return itsoftApp.commonVars.viewHeight;
            },

            getHeaderHeight: function () {
                itsoftApp.commonVars.headerHeight = pageHeader.offsetHeight;
                return itsoftApp.commonVars.headerHeight;
            },

            getDisclaimerHeight: function () {
                const disclaimer = document.querySelector(".disclaimer");
                return disclaimer && disclaimer.offsetHeight;
            },

            getCoords: function (el) {
                var box = el.getBoundingClientRect();

                return {
                    top: box.top + pageYOffset,
                    left: box.left + pageXOffset
                };
            }
        },

        loadScript: function (url, callback, error) {
            var script;
            script = document.createElement("script");

            // If "fallback" url passed as second argument
            var args = Array.prototype.slice.call(arguments);
            if (typeof callback === "string") {
                var fallbackUrl = callback;
                callback = error;
                var errorOri = args[3];
                error = function () {
                    DEBUG && console.log("%c[common] error while loading script: " + url + ". trying to load a fallback url: " + fallbackUrl, "color: red");
                    itsoftApp.loadScript(fallbackUrl, callback, errorOri);

                    if (!DEBUG && typeof Raven !== "undefined") {
                        Raven.captureMessage("[common] error while loading script", {
                            level: "warning", // one of 'info', 'warning', or 'error'
                            extra: {
                                "script": url,
                                "fallback": fallbackUrl
                            }
                        });
                    }
                };
            }

            var cb = function () {
                DEBUG && console.log("%c--[common] finished loading script: " + url, "color: #999");
                if (typeof callback === "function") {
                    callback();
                }
            };

            // IE
            if (script.readyState) {
                script.onreadystatechange = function () {
                    if (script.readyState === "loaded" || script.readyState === "complete") {
                        script.onreadystatechange = null;
                        cb();
                    }
                };

            // Normal browsers
            } else {
                if (typeof error === "function") {
                    script.onerror = error;
                }
                script.onload = cb;
            }

            script.src = url;
            document.getElementsByTagName("body")[0].appendChild(script);
            DEBUG && console.log("%c--[common] starting to load script: " + url, "color: #999");
        },

        loadStyle: function (url) {
            var first, head, link;
            link = document.createElement("link");
            link.href = url;
            link.rel = "stylesheet";
            link.type = "text/css";
            head = document.getElementsByTagName("head")[0];
            first = head.firstChild;

            // Prepend styles in 'head' section
            head.insertBefore(link, first);
        },

        features: {
            // From Modernizr
            transitionEventEnd: (function () {
                var el, t, transitions;
                el = document.createElement("fakeelement");
                transitions = {
                    "transition": "transitionend",
                    "OTransition": "oTransitionEnd",
                    "MozTransition": "transitionend",
                    "WebkitTransition": "webkitTransitionEnd"
                };
                for (t in transitions) {
                    if (el.style[t] !== undefined) {
                        el = null;
                        return transitions[t];
                    }
                }
                return false;
            })()
        },

        modules: {},

        initializedModules: [],

        createModule: function () {
            var dep, dependencies, i, initFunc, j, len, mName, module, options, ref;
            mName = arguments[0], options = 3 <= arguments.length ? slice.call(arguments, 1, i = arguments.length - 1) : (i = 1, []), initFunc = arguments[i++];
            if (typeof initFunc !== "function") {
                throw "Missing an initialization function for module '" + mName + "'";
            }

            // Create a namespace
            module = itsoftApp.createNS("modules." + mName);
            module.__mName__ = mName;
            module.initialized = false;

            // Set dependencies
            if (options.length && options[0].length) {
                dependencies = [];
                ref = options[0];
                for (j = 0, len = ref.length; j < len; j++) {
                    dep = ref[j];
                    if (typeof dep === "string" && dependencies.indexOf(dep) < 0 && dep !== mName) {
                        dependencies.push(dep);
                    }
                }
                if (dependencies.length) {
                    module.dependencies = dependencies;
                }
            }

            // Set initialization function and behavior
            module.init = function () {
                var depModule, e, initTime, initializedModules, l, len1, t1, t2;
                try {
                    if (module.dependencies) {
                        for (l = 0, len1 = dependencies.length; l < len1; l++) {
                            dep = dependencies[l];
                            depModule = itsoftApp.modules[dep];
                            if (!depModule) {
                                DEBUG && console.log("%c[modules] missed module " + dep + " as a dependency for module " + mName + ". (it's ok only if module is not required for this page)", "color: #BB6565; font-style: italic");
                                return false;
                            }
                            if (depModule.initialized) {
                                continue;
                            }
                            depModule.init();
                            if (!depModule.initialized) {
                                DEBUG && console.log("%c[modules] can't init module " + dep + " as a dependency for module " + mName + ". (it's ok only if module is not required for this page)", "color: #BB6565; font-style: italic");
                                return false;
                            }
                        }
                    }
                    t1 = itsoftApp.utils.getTime();
                    if (initFunc.call(module) !== false) {

                        t2 = itsoftApp.utils.getTime();
                        initTime = parseFloat((t2 - t1).toFixed(1));
                        module.__initTime__ = initTime;
                        DEBUG && console.log("[module " + mName + "] module initialized in " + initTime + " ms");
                        module.initialized = true;
                        initializedModules = itsoftApp.initializedModules || [];
                        initializedModules.push(mName);
                        itsoftApp.initializedModules = initializedModules;
                    }
                } catch (error1) {
                    e = error1;
                    if (typeof Raven !== "undefined") {
                        Raven.captureException(e);
                    }
                    itsoftApp.errorHandler(e, {
                        moduleName: mName
                    });
                }
            };
            return module;
        },

        errorHandler: function (error, options) {
            var pre;
            pre = "[error]";
            if (options && options.moduleName) {
                pre += "[module " + options.moduleName + "]";
            }
            if (console && console.error) {
                console.error(pre + "\n" + error + "\nNavigator: " + window.navigator.userAgent);
            }
        }
    };

    // Unit-tests for itsoftApp object
    if (DEBUG && typeof mocha !== "undefined" && typeof describe === "function") {
        mocha.setup("bdd");
        describe("itsoftApp object tests", function () {
            it("Should be an object", function () {
                expect(itsoftApp).to.be.an("object");
            });
            it("Should contain a loadScript function", function () {
                expect(itsoftApp.loadScript).to.be.a("function");
            });
            it("Should contain a loadStyle function", function () {
                expect(itsoftApp.loadStyle).to.be.a("function");
            });
            it("We can create a deep namespace scope with a string like 'ns1.ns2.ns3'", function () {
                itsoftApp.createNS("ns1.ns2.ns3");
                expect(itsoftApp.ns1).to.be.an("object");
                expect(itsoftApp.ns1.ns2).to.be.an("object");
                expect(itsoftApp.ns1.ns2.ns3).to.be.an("object");
                delete itsoftApp.ns1;
            });
            it("initializedModules must be defined from the start", function () {
                expect(itsoftApp.initializedModules).to.be.an("array");
            });

            describe(".modules", function () {
                it("Should be a function to create modules", function () {
                    expect(itsoftApp.createModule).to.be.a("function");
                });
                it("We can simply create a single module", function () {
                    var module, testFunc;
                    testFunc = function () {
                        console.log("test module init");
                    };
                    var mName = "testmodule" + Math.round(Math.random() * 100);
                    module = itsoftApp.createModule(mName, testFunc);
                    expect(module).to.be.equal(itsoftApp.modules[mName]);
                    itsoftApp.initializedModules.splice(itsoftApp.initializedModules.indexOf(mName), 1);
                    delete itsoftApp.modules[mName];
                });
                it("We can't create a module without initialization function", function () {
                    var module;
                    module = function () {
                        itsoftApp.createModule("testmodule");
                    };
                    expect(module).to["throw"];
                });
                it("Each module must have an init function", function () {
                    var module;
                    for (module in itsoftApp.modules) {
                        expect(itsoftApp.modules[module].init).to.be.a("function");
                    }
                });
                it("Should throw an exception if we try to initialize a module twice", function () {
                    var mName, module, testFunc;
                    mName = "testmodule" + Math.round(Math.random() * 100);
                    testFunc = function () {
                        return 1;
                    };
                    module = itsoftApp.createModule(mName, testFunc);
                    module.init();
                    expect(module.init).to["throw"];
                    itsoftApp.initializedModules.splice(itsoftApp.initializedModules.indexOf(mName), 1);
                    delete itsoftApp.modules[mName];
                });
            });
        });
    }



    var itsoftAppInitFunc = function () {
        var init = function () {
            itsoftApp.commonVars = {
                $document: document.documentElement,
                $body: document.body,
                $window: window,
                $wrapper: document.querySelector(".l-wrapper"),
                headerHeight: undefined,
                viewWidth: undefined
            };

            var benchmarkCloseBtn, benchmarkDiv, criticalInitTime, dColor, fTime, initTimes, m, module, moduleName, t, time, warningModules;
            if (DEBUG) {
                t = itsoftApp.utils.getTime();
            }

            itsoftApp.ajaxDisabled = false; //нужно для работы с аяксовыми переходами.

            itsoftApp.removeAllModules = function () {
                for (m in itsoftApp.modules) {
                    module = itsoftApp.modules[m];
                    module.initialized = false;
                }

                itsoftApp.initializedModules = [];

                DEBUG && console.log("%c[common] all modules removed", "font-weight: bold;");
            };

            itsoftApp.initAllModules = function () {
                // Initialize itsoftApp modules
                itsoftApp.removeAllModules();

                for (m in itsoftApp.modules) {
                    module = itsoftApp.modules[m];
                    if (!module.initialized && typeof module.init === "function") {
                        module.init();
                    }
                }
            };

            itsoftApp.initAllModules();

            if (DEBUG) {
                fTime = Math.round(itsoftApp.utils.getTime() - t);
                dColor = fTime < 200 ? "green" : "red";
                console.log("%c[common] document ready event fired, " + itsoftApp.initializedModules.length + " modules initialized in " + fTime + " ms: " + ((function () {
                    var i, len, ref, results;
                    ref = itsoftApp.initializedModules;
                    results = [];
                    for (i = 0, len = ref.length; i < len; i++) {
                        m = ref[i];
                        results.push(" " + m + "(" + itsoftApp.modules[m].__initTime__ + "ms)");
                    }
                    return results;
                })()), "color: " + dColor);
            }

            // Add benchmark div
            benchmarkDiv = document.getElementById("benchmark");
            if (typeof itsoftApp.utils.getInitTimes === "function" && (DEBUG || window.location.hash === "#benchmark") && !benchmarkDiv) {
                benchmarkDiv = document.createElement("div");
                benchmarkDiv.className = "benchmark";
                benchmarkDiv.id = "benchmark";
                if (typeof itsoftApp.utils.getInitTimes === "function") {
                    benchmarkDiv.innerHTML = "<small style=\"opacity: 0.7\">modules (ms):" + ((function () {
                        var ref, results;
                        ref = itsoftApp.utils.getInitTimes();
                        results = [];
                        for (m in ref) {
                            t = ref[m];
                            results.push(" " + m + ": " + t);
                        }
                        return results;
                    })()) + "</small>";
                }

                // Add close button
                benchmarkCloseBtn = document.createElement("a");
                benchmarkCloseBtn.onclick = function () {
                    benchmarkDiv.parentNode.removeChild(benchmarkDiv);
                };
                benchmarkCloseBtn.innerHTML = "X";
                benchmarkCloseBtn.className = "benchmark__close";
                benchmarkDiv.appendChild(benchmarkCloseBtn);
                document.body.appendChild(benchmarkDiv);
            }

            // Check for "too complex" modules
            // WARNING иногда такие "ошибки" возникают спонтанно
            // (например, все модули инициализируются за 0-2 мс, а один "выстрелил" на 300 мс).
            // Если это станет мешать проектам, то можно данные предупреждения
            // из логгера убрать.
            if (!DEBUG && typeof Raven !== "undefined") {
                initTimes = itsoftApp.utils.getInitTimes();
                warningModules = [];
                criticalInitTime = 50;
                for (moduleName in initTimes) {
                    time = initTimes[moduleName];
                    if (moduleName === "all") {
                        continue;
                    }
                    if (time > criticalInitTime) {
                        warningModules.push(moduleName);
                    }
                }

                //  CHANGED: Вот именно из-за того, что один из модулей может
                //  случайно инициализироваться за какое-то неадекватно большое для него время.
                //  if warningModules.length > 0
                if (warningModules.length > 1) {
                    Raven.captureMessage("[common] detected some \"long\" (initTime > " + criticalInitTime + " ms) modules", {
                        level: "warning", // one of 'info', 'warning', or 'error'
                        extra: initTimes
                    });
                }
            }

            // If unit tests library loaded, just load a file with tests
            if (typeof mocha !== "undefined") {
                mocha.setup("bdd");
                mocha.run();
            }
        };

        if ("addEventListener" in document) {
            init();
        }
    };

    // Document ready event
    if ("addEventListener" in document) {
        document.addEventListener("DOMContentLoaded", itsoftAppInitFunc, false);

    // .. IE <= 8
    } else if ("attachEvent" in document) {
        document.attachEvent("onreadystatechange", function () {
            if (document.readyState === "complete") {
                itsoftAppInitFunc();
            }
        });
    }
})();